import type { SlideData } from "../../components/HeroSection/HeroSlide/HeroSlide";
import i18n from "../../i18nt/index";
import GeoInfraMonitoringImg from "../../assets/pages/home/hero/geo-infra-monitoring.jpg";
import DesignImg from "../../assets/pages/home/hero/design.jpg";
import EnergyEfficiencyImg from "../../assets/pages/home/hero/energy-efficiency.jpg";
import EnvironmentalProtectionImg from "../../assets/pages/home/hero/environmental-protection.jpg";
import FireProtectionImg from "../../assets/pages/home/hero/fire-protection.jpg";
import FirstAidImg from "../../assets/pages/home/hero/first-aid.jpg";
import InspectionsTestingImg from "../../assets/pages/home/hero/inspections-testing.jpg";
import PredictiveMaintenanceImg from "../../assets/pages/home/hero/predictive-maintenance.jpg";
import ProfessionalTrainingImg from "../../assets/pages/home/hero/professional-training.jpg";
import SiteSafetyCoordinatorImg from "../../assets/pages/home/hero/site-safety-coordinator.jpg";
//import StandardizationImg from "../../assets/pages/home/hero/standardization.jpg";
import SupervisionImg from "../../assets/pages/home/hero/supervision.jpg";
import WorkSafetyHealthImg from "../../assets/pages/home/hero/work-safety-health.jpg";
import { PAGES } from "../pages";

const heroKey = "pages.home.hero.slides";

export const ourService: SlideData[] = [
  {
    id: 2,
    title: i18n.t(`${heroKey}.slide2.title`),
    description: i18n.t(`${heroKey}.slide2.description`),
    ctaText: i18n.t(`${heroKey}.slide2.ctaText`),
    ctaLink: PAGES.GEO_INFRA_MONITORING.route ?? "/",
    imageUrl: GeoInfraMonitoringImg,
    maxWidth: "240px",
  },
  {
    id: 3,
    title: i18n.t(`${heroKey}.slide3.title`),
    description: i18n.t(`${heroKey}.slide3.description`),
    ctaText: i18n.t(`${heroKey}.slide3.ctaText`),
    ctaLink: PAGES.SUPERVISION.route ?? "/",
    imageUrl: SupervisionImg, // Mapped to 'Nadzor'
  },
  {
    id: 4,
    title: i18n.t(`${heroKey}.slide4.title`),
    description: i18n.t(`${heroKey}.slide4.description`),
    ctaText: i18n.t(`${heroKey}.slide4.ctaText`),
    ctaLink: PAGES.PREDICTIVE_MAINTENANCE.route ?? "/",
    imageUrl: PredictiveMaintenanceImg,
    maxWidth: "165px",
  },
  {
    id: 5,
    title: i18n.t(`${heroKey}.slide5.title`),
    description: i18n.t(`${heroKey}.slide5.description`),
    ctaText: i18n.t(`${heroKey}.slide5.ctaText`),
    ctaLink: PAGES.WORK_SAFETY_HEALTH.route ?? "/",
    imageUrl: WorkSafetyHealthImg, // Mapped to 'Bezbednost i zdravlje na radu'
    maxWidth: "252px",
  },
  {
    id: 6,
    title: i18n.t(`${heroKey}.slide6.title`),
    description: i18n.t(`${heroKey}.slide6.description`),
    ctaText: i18n.t(`${heroKey}.slide6.ctaText`),
    ctaLink: PAGES.SITE_SAFETY_COORDINATOR.route ?? "/",
    imageUrl: SiteSafetyCoordinatorImg, // Mapped to 'Koordinator za bezbednost i zdravlje na gradilištima'
  },
  {
    id: 7,
    title: i18n.t(`${heroKey}.slide7.title`),
    description: i18n.t(`${heroKey}.slide7.description`),
    ctaText: i18n.t(`${heroKey}.slide7.ctaText`),
    ctaLink: PAGES.ENERGY_EFFICIENCY.route ?? "/",
    imageUrl: EnergyEfficiencyImg,
    maxWidth: "186px",
  },
  {
    id: 8,
    title: i18n.t(`${heroKey}.slide8.title`),
    description: i18n.t(`${heroKey}.slide8.description`),
    ctaText: i18n.t(`${heroKey}.slide8.ctaText`),
    ctaLink: PAGES.DESIGN.route ?? "/",
    imageUrl: DesignImg, // Mapped to 'Projektovanje'
  },
  {
    id: 9,
    title: i18n.t(`${heroKey}.slide9.title`),
    description: i18n.t(`${heroKey}.slide9.description`),
    ctaText: i18n.t(`${heroKey}.slide9.ctaText`),
    ctaLink: PAGES.FIRE_PROTECTION.route ?? "/",
    imageUrl: FireProtectionImg,
    maxWidth: "169px",
  },
  {
    id: 10,
    title: i18n.t(`${heroKey}.slide10.title`),
    description: i18n.t(`${heroKey}.slide10.description`),
    ctaText: i18n.t(`${heroKey}.slide10.ctaText`),
    ctaLink: PAGES.ENVIRONMENTAL_PROTECTION.route ?? "/",
    imageUrl: EnvironmentalProtectionImg,
    maxWidth: "246px",
  },
  /*{
    id: 11,
    title: i18n.t(`${heroKey}.slide11.title`),
    description: i18n.t(`${heroKey}.slide11.description`),
    ctaText: i18n.t(`${heroKey}.slide11.ctaText`),
    ctaLink: PAGES.STANDARDIZATION.route ?? "/",
    imageUrl: StandardizationImg,
  },*/
  {
    id: 12,
    title: i18n.t(`${heroKey}.slide12.title`),
    description: i18n.t(`${heroKey}.slide12.description`),
    ctaText: i18n.t(`${heroKey}.slide12.ctaText`),
    ctaLink: PAGES.FIRST_AID.route ?? "/",
    imageUrl: FirstAidImg,
    maxWidth: "123px",
  },
  {
    id: 13,
    title: i18n.t(`${heroKey}.slide13.title`),
    description: i18n.t(`${heroKey}.slide13.description`),
    ctaText: i18n.t(`${heroKey}.slide13.ctaText`),
    ctaLink: PAGES.PROFESSIONAL_TRAINING.route ?? "/",
    imageUrl: ProfessionalTrainingImg, // Mapped to 'Stručno osposobljavanje i obuke'
    maxWidth: "258px",
  },
  {
    id: 14,
    title: i18n.t(`${heroKey}.slide14.title`),
    description: i18n.t(`${heroKey}.slide14.description`),
    ctaText: i18n.t(`${heroKey}.slide14.ctaText`),
    ctaLink: PAGES.INSPECTIONS_TESTING.route ?? "/",
    imageUrl: InspectionsTestingImg, // Mapped to 'Pregledi i ispitivanja'
    maxWidth: "172px",
  },
];
